var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.role === _vm.constants.ROLE_SUPER_ADMIN ? _c('div', {
    staticClass: "lg:mx-5"
  }, [_c('div', {
    staticClass: "text-5xl mb-1"
  }, [_vm._v("\n    Bonjour,\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 text-2xl font-light mb-20"
  }, [_vm._v("\n    Que souhaitez-vous faire aujourd'hui ?\n  ")])]) : _c('div', [!_vm.isOF ? _c('popup-job-desc', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isROME,
      expression: "!isROME"
    }],
    attrs: {
      "show": _vm.showJobDesc,
      "id": _vm.shownJobId,
      "opened-from-edit-button": true
    },
    on: {
      "mutateShow": function (newValue) {
        _vm.showJobDesc = newValue;
      },
      "mutateId": function (newValue) {
        _vm.shownJobId = newValue;
      }
    }
  }) : _vm.isOF ? _c('popup-ref-formation', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isROME,
      expression: "!isROME"
    }],
    attrs: {
      "show": _vm.showJobDesc,
      "id": _vm.shownJobId,
      "opened-from-edit-button": true
    },
    on: {
      "mutateShow": function (newValue) {
        _vm.showJobDesc = newValue;
      },
      "mutateId": function (newValue) {
        _vm.shownJobId = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('popup-fiche-r-o-m-e', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isROME,
      expression: "isROME"
    }],
    attrs: {
      "show": _vm.showJobDesc,
      "id": _vm.shownJobId,
      "opened-from-edit-button": true
    },
    on: {
      "mutateShow": function (newValue) {
        _vm.showJobDesc = newValue;
      },
      "mutateId": function (newValue) {
        _vm.shownJobId = newValue;
      }
    }
  }), _vm._v(" "), _c('popup-activated-account', {
    attrs: {
      "opened": _vm.isPopupActivatedAccount
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateActivatedAccountPopup(false);
      }
    }
  }), _vm._v(" "), _c('add-new-neopass-popup', {
    attrs: {
      "add-neopass-display": _vm.addNeopassDisplay
    },
    on: {
      "close": function ($event) {
        _vm.addNeopassDisplay = -1;
      },
      "open": _vm.openPopupNewNeopass,
      "changeStep": function (numStep) {
        _vm.addNeopassDisplay = numStep;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lg:mx-5"
  }, [_c('div', {
    staticClass: "text-5xl mb-1"
  }, [_vm._v("\n      Bonjour " + _vm._s(_vm.user.firstname) + "\n    ")]), _vm._v(" "), _vm.structures.length > 1 && !_vm.$freeParticulier() && _vm.role != _vm.constants.ROLE_BENEFICIAIRE ? _c('div', {
    staticClass: "flex space-x-4 w-full items-center"
  }, [_c('p', {
    staticClass: "w-max"
  }, [_vm._v("\n        Choisir la structure :\n      ")]), _vm._v(" "), _c('input-select', {
    staticClass: "md:w-1/4",
    attrs: {
      "name": "choice_structure",
      "value": _vm.structure,
      "datas": _vm.structures,
      "libelle": "",
      "empty-case": false,
      "value-is-object": true
    },
    on: {
      "input": function (newValue) {
        _vm.changeStructureAndReloadInfos(newValue.id);
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 text-2xl font-light mb-20"
  }, [_vm._v("\n      Que souhaitez-vous faire aujourd'hui ?\n    ")]), _vm._v(" "), _vm.listPermissions.length > 0 ? _c('div', {
    staticClass: "flex flex-col space-y-10 md:space-y-0 md:h-130 xl:h-150 md:gap-4 xl:gap-8 md:grid md:grid-flow-row md:grid-rows-2 md:grid-cols-3"
  }, _vm._l(_vm.listPermissions, function (module, km) {
    return _c('div', {
      key: km,
      class: {
        'col-span-1': module.position === 1,
        'col-span-2': module.position === 2,
        'col-span-1 row-span-2': module.position === 3
      }
    }, [module.name === _vm.constants.MODULE_NEOPASS_FORM ? _c('neopass-list', {
      attrs: {
        "list-neopass": _vm.beneficiaries,
        "position": module.position
      },
      on: {
        "displayAddNeopassPopup": function ($event) {
          return _vm.openPopupNewNeopass();
        }
      }
    }) : _vm._e(), _vm._v(" "), module.name === 'collectiveCartography' ? _c('collective-cartography', {
      attrs: {
        "datas": _vm.gender,
        "position": module.position
      }
    }) : _vm._e(), _vm._v(" "), module.name === 'individualCartography' ? _c('individual-cartography', {
      attrs: {
        "position": module.position
      }
    }) : _vm._e(), _vm._v(" "), module.name === _vm.constants.MODULE_MODELE_DE_PAGE ? _c('templates-list', {
      attrs: {
        "list-page-templates": _vm.listPageTemplates,
        "position": module.position
      }
    }) : _vm._e(), _vm._v(" "), module.name === 'jobDescription' ? _c('job-description-list', {
      attrs: {
        "list-descs": _vm.listDescs,
        "position": module.position
      },
      on: {
        "showJobDesc": function (id) {
          return _vm.displayJobDesc(id);
        }
      }
    }) : _vm._e(), _vm._v(" "), module.name === 'help' ? _c('help-bloc', {
      attrs: {
        "position": module.position
      }
    }) : _vm._e()], 1);
  }), 0) : _c('div', {
    staticClass: "flex flex-col space-y-10 md:space-y-0 md:h-130 xl:h-150 md:gap-4 xl:gap-8 md:grid md:grid-flow-row md:grid-rows-2 md:grid-cols-3"
  }, [_c('div', {
    staticClass: "col-span-full text-center"
  }, [_c('illustration', {
    staticClass: "mx-auto my-5",
    attrs: {
      "name": "notAllowed"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-xl text-pink-600"
  }, [_vm._v("Vous ne disposez pas des droits vous permettant d'accéder aux\n          fonctionnalités du tableau de bord.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-base"
  }, [_vm._v("Vous pouvez tout de même accéder aux fonctionnalités dont vous\n          disposez des droits d'accès.")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-md text-gray-500 italic"
  }, [_vm._v("Si vous pensez qu'il s'agit d'une erreur, contactez votre référent\n          Neopass.")])], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }